import { useRef } from 'react';
import LevelsList from './-List';
import {
    createFileRoute,
    Outlet,
    stripSearchParams,
} from '@tanstack/react-router';
import { defaultListParams, listParamsSchema } from './-SearchParams';
import { seo } from '~/util';
import { useScrollIntoViewOnMobile } from '~/util/hooks/useScrollIntoViewOnMobile';

export const Route = createFileRoute('/list')({
    validateSearch: listParamsSchema,
    search: {
        middlewares: [stripSearchParams(defaultListParams)],
    },
    head: () => ({
        meta: seo({
            title: 'Demon List',
        }),
    }),
    wrapInSuspense: true,
    component: List,
});
function List() {
    const infoRef = useRef<HTMLDivElement>(null);
    const scrollToInfo = useScrollIntoViewOnMobile(infoRef);

    return (
        <div
            className="flex h-[calc(100vh-120px)] overflow-y-hidden overflow-x-scroll snap-x snap-mandatory gap-x-2 lg:flex-1 lg:overflow-x-hidden lg:snap-none"
            style={{ WebkitOverflowScrolling: 'touch' }}
        >
            <section className="flex shrink-0 w-screen snap-center overflow-y-hidden lg:snap-none lg:shrink lg:basis-1/4 lg:min-w-0 lg:flex-col lg:w-max lg:flex-1 h-full lg:overflow-x-hidden bg-background-dark rounded-2xl">
                <LevelsList onLevelSelect={scrollToInfo} />
            </section>

            <section
                ref={infoRef}
                className="flex shrink-0 lg:snap-none h-full lg:shrink lg:basis-3/4 lg:min-w-0 lg:flex-3 gap-x-2"
            >
                <Outlet />
            </section>
        </div>
    );
}
